"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileLocale = exports.Locale = exports.translate = exports.messages = void 0;
var lodash_1 = require("lodash");
var react_intl_1 = require("react-intl");
var action_1 = require("./messages/action");
var alert_1 = require("./messages/alert");
var auth_1 = require("./messages/auth");
var configuration_1 = require("./messages/configuration");
var deviceStatus_1 = require("./messages/deviceStatus");
var deliveryCycles_1 = require("./messages/deliveryCycles");
var trail_1 = require("./messages/trail");
var error_1 = require("./messages/error");
var feedback_1 = require("./messages/feedback");
var field_1 = require("./messages/field");
var general_1 = require("./messages/general");
var icons_1 = require("./messages/icons");
var ironhide_1 = require("./messages/ironhide");
var map_1 = require("./messages/map");
var menu_1 = require("./messages/menu");
var modal_1 = require("./messages/modal");
var place_1 = require("./messages/place");
var reports_1 = require("./messages/reports");
var role_1 = require("./messages/role");
var schedule_1 = require("./messages/schedule");
var mobileApp_1 = require("./messages/mobileApp");
var routePlanner_1 = require("./messages/routePlanner");
var command_1 = require("./messages/command");
var utils_1 = require("./utilities/utils");
var routeUsers_1 = require("./messages/routeUsers");
var announcements_1 = require("./messages/announcements");
var localMessages = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, action_1.default), alert_1.default), auth_1.default), configuration_1.default), deviceStatus_1.default), error_1.default), feedback_1.default), field_1.default), general_1.default), icons_1.default), ironhide_1.default), map_1.default), menu_1.default), modal_1.default), place_1.default), reports_1.default), role_1.default), schedule_1.default), mobileApp_1.default), routePlanner_1.default), deliveryCycles_1.default), trail_1.default), routeUsers_1.default), announcements_1.default), command_1.default);
exports.messages = (0, react_intl_1.defineMessages)((0, lodash_1.reduce)(localMessages, function (result, value, key) {
    result[key] || (result[key] = { id: key, defaultMessage: value.en });
    if (value.aka) {
        value.aka.map(function (alias) {
            result[alias] ||
                (result[alias] = { id: alias, defaultMessage: value.en });
        });
    }
    return result;
}, {}));
var translate = function (key) {
    if (key in exports.messages) {
        return exports.messages[key];
    }
    return { id: "no-translation", defaultMessage: "[".concat(key, "]") };
};
exports.translate = translate;
exports.Locale = (0, lodash_1.reduce)(localMessages, function (result, value, key) {
    var _a, _b;
    var aka = value.aka, en = value.en, es = value.es;
    result.en = __assign(__assign({}, result.en), (_a = {}, _a[key] = en, _a));
    result.es = __assign(__assign({}, result.es), (_b = {}, _b[key] = es, _b));
    if (aka) {
        aka.map(function (alias) {
            var _a, _b;
            result.en = __assign(__assign({}, result.en), (_a = {}, _a[alias] = en, _a));
            result.es = __assign(__assign({}, result.es), (_b = {}, _b[alias] = es, _b));
        });
    }
    return result;
}, { en: {}, es: {} });
exports.MobileLocale = (0, lodash_1.reduce)(localMessages, function (result, value, key) {
    var _a, _b;
    var aka = value.aka, en = value.en, es = value.es;
    result.en = __assign(__assign({}, result.en), (_a = {}, _a[key] = (0, utils_1.removeSingleQuotes)(en), _a));
    result.es = __assign(__assign({}, result.es), (_b = {}, _b[key] = (0, utils_1.removeSingleQuotes)(es), _b));
    if (aka) {
        aka.map(function (alias) {
            var _a, _b;
            result.en = __assign(__assign({}, result.en), (_a = {}, _a[alias] = (0, utils_1.removeSingleQuotes)(en), _a));
            result.es = __assign(__assign({}, result.es), (_b = {}, _b[alias] = (0, utils_1.removeSingleQuotes)(es), _b));
        });
    }
    return result;
}, { en: {}, es: {} });
